module.exports = __webpack_public_path__ + "img/Suzhi Bi.5226dccf.jpg";